import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import Benefit from "../../../../V2/Cards/Packages/Machine/Benefit"

import {
  useGetEcoSystemObjectFields,
  useGetPurchasableItem,
} from "@hooks/V2/storyblok"
import { getUrlFromStoryblokLink } from "@utils/storyblok"

const StoryblokMachineBenefitCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.MachineBenefitCard>) => {
  const getEcoSystemObjectFields = useGetEcoSystemObjectFields()
  const getPurchasableItem = useGetPurchasableItem()

  const ecoSystemFields = getEcoSystemObjectFields(blok?.bundleConfig)
  const purchasableItem = getPurchasableItem(
    blok?.bundleConfig.uuid,
    blok?.bundleConfig.content
  )

  return (
    <Benefit
      mobileGridOrder={mobileGridOrder}
      backgroundColor={blok.backgroundColor}
      heading={ecoSystemFields.name || ""}
      accentColor={blok.accentColor}
      description={ecoSystemFields.shortDescription || ""}
      priceValue={ecoSystemFields.price || 0}
      priceSuperscriptText={
        ecoSystemFields.onPromotion
          ? `Was R${ecoSystemFields.originalPrice}`
          : undefined
      }
      priceAdornmentText={ecoSystemFields.adornmentText}
      priceStrikeSuperscriptText={ecoSystemFields.onPromotion || false}
      adornmentTextPosition={ecoSystemFields.adornmentTextPosition}
      priceSubscriptText={ecoSystemFields.priceSubScript}
      pillButtonText={blok.primaryCtaText}
      pillButtonUrl={getUrlFromStoryblokLink(blok.primaryCtaLink)}
      priceSideScriptText={ecoSystemFields.priceSideScript}
      bundleIncludesTitle={blok.buyerReceivesTitle}
      bundleIncludesList={blok.buyerReceivesList}
      badgeText={blok.badge}
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      purchasableItem={purchasableItem}
      purchasable={blok.purchasable}
      reasonNotAvailable={ecoSystemFields.reasonNotAvailable}
      waitlistLink={ecoSystemFields.waitlistLink}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokMachineBenefitCard
